import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var SortUpIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 6 15" }),
        React.createElement("path", { d: "M2.09324 3.43427V13.4571C2.09324 13.9578 2.50289 14.3675 3.00358 14.3675C3.50427 14.3675 3.91392 13.9578 3.91392 13.4571V3.43427H5.54343C5.95309 3.43427 6.15336 2.94268 5.86205 2.66047L3.3222 0.129724C3.14013 -0.0432413 2.85792 -0.0432413 2.67585 0.129724L0.136 2.66047C-0.155309 2.94268 0.054069 3.43427 0.45462 3.43427H2.09324Z" })));
};

export { SortUpIcon };
//# sourceMappingURL=SortUpIcon.esm.js.map
